import { useEffect, useRef } from 'react'

import {
  MainInventoryMapper,
  NotQuestStage,
  QuestId,
  useAvailableQuestsState,
  useInventory,
  useInventoryStoreBase,
  useQuestCurrentStage,
  useUser,
} from '@store'

import { NOT_QUEST_KEY_ITEM_ID } from '../../constats'

export const useFetchNotReward = (enabled: boolean) => {
  const alreadyFetched = useRef(false)
  const availableQuests = useAvailableQuestsState()
  const { claimNotReward } = useUser().actions
  const { addCard } = useInventoryStoreBase.getState().actions
  const { currentStage: notQuestStage, isLoading: notQuestInfoLoading } =
    useQuestCurrentStage(QuestId.NotQuest)
  const inventory = useInventory().items

  useEffect(() => {
    if (alreadyFetched.current) return
    if (!enabled) return
    if (notQuestInfoLoading) return
    if (inventory.some((card) => card.itemDefId === NOT_QUEST_KEY_ITEM_ID))
      return
    if (notQuestStage !== NotQuestStage.Lock + 1) return
    if (
      availableQuests.find(
        (quest) => quest.slug === QuestId.Eye && quest.isSolved
      )
    ) {
      alreadyFetched.current = true
      claimNotReward().then((reward) => {
        if (reward) {
          addCard(MainInventoryMapper.mapFromBackend(reward))
        }
      })
    }
  }, [availableQuests, notQuestStage, inventory, notQuestInfoLoading, enabled])
}
